<template>
  <div>
    <div id="signup">
      <!-- CONTAIN_START -->
      <div id="contain">
        <div class="container-inner">
          <div class="account-creation account-creation-v4 container-inner_account-creation">
            <div class="account-creation_wrapper">
              <img class="account-creation_logo" :src="signUpImg" alt="sign up img" />
              <div class="promise-text-v2">
                <span>We require an email to authenticate</span>
                <br>
                <span>that you're a real person.</span>
              </div>
              <!-- Form -->
              <form class="step5 mailgun_validation js-submit-once" data-submitted="false" method="post">
                <div class="row main-form">
                  <div class="main-form-inner">
                    <div class="main-form-inner-left">
                      <div class="main-form-text">
                        <input autofocus type="email" name="email" id="email" v-model="email"
                          :placeholder="'Enter email address'" />
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="text-center">
                    <div id="validation_error_email" class="validation-errors"></div>
                  </div>
                  <div id="status" class="validation-errors"></div>
                  <div class="main-form-inner">
                    <div class="main-form-inner-left">
                      <div class="main-form-text">
                        <div id="contain_pass">
                          <input :type="this.showPassword ? 'text' : 'password'" name="password" id="password"
                            class="password_num" v-model="password" :placeholder="'Create a password'" />
                        </div>
                        <div class="clearfix"></div>
                        <div class="password-format">Only numbers, letters, dashes and underscores.</div>
                        <div class="account-creation_show-password">
                          <input class="account-creation_checkbox" type="checkbox" id="show_pass"
                            @click="togglePassword" />
                          <label for="show_pass" class="account-creation_checkbox-text">
                            Show
                            password
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <div id="validation_error_password" class="validation-errors"></div>
                  </div>

                  <div class="text-center">
                    <div id="validation_error_captcha" class="validation-errors"></div>
                  </div>
                </div>

                <div id="existing-user" class="hidden validation-errors">
                  <label class="error">
                    Your account already exists <br> but you’ve entered an incorrect password.
                    <div class="center">
                      <a @click="freePasswordLink" href="">Send me a password-free login link</a> <br>
                      or <br>
                      <a href="/accounts/password/reset/">Reset my Password</a>
                    </div>
                  </label>
                </div>
                <div id="free-password-ok" class="hidden">We sent the link. Please check your email!</div>

                <div class="step-button">
                  <button v-if="shouldRenderRecaptcha" id="submit_btn"
                    class="btn btn-default btn-step validate_submit g-recaptcha" v-bind:disabled="btnClicked"
                    :data-sitekey="gcaptchaId" data-callback="processSignup" data-badge="bottomright"
                    data-size="invisible">
                    Show Prize Amount
                  </button>
                  <input v-else value="Show Prize Amount" type="button" id="submit_btn"
                    class="btn btn-default btn-step validate_submit" v-bind:disabled="btnClicked" @click="onSignUp" />
                </div>

                <div class="account-creation_facebook_separator" v-show="this.showFBButton">
                  Or get your prize amount by
                  <br class="hidden-sm hidden-md hidden-lg" />continuing with Facebook
                </div>
                <a @click="signUpFacebook" class="fb fb-proceed connect" v-show="this.showFBButton">{{facebookBtnText}}</a>
                <div class="account-creation_facebook_separator-proceed" v-show="this.showFBButton">We won’t post without your permission.</div>
              </form>

              <!-- Warranties -->
              <div class="warranties" style="margin-top:20px;">
                <div class="warranties_item">
                  <span class="warranties_img">
                    <img :src="lockIcon" alt="Secure Payment" />
                  </span>
                  <span class="warranties_text">
                    <span class="warranties_title">Privacy guarantee</span>
                    <span class="warranties_description">We safeguard your privacy and do not sell your
                      information.</span>
                  </span>
                </div>
                <div class="warranties_item warranties_item_2">
                  <span class="warranties_img">
                    <img class="warranties_img" :src="accImg" alt="Godaddy verified" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="message">
            <div class="message_icon-holder">
              <img :src="step2Img" alt />
            </div>
            <div class="message_text">
              When you need motivation, you will visualize what you plan to buy with your winnings!
              Powerful stuff!
            </div>
          </div>
        </div>
      </div>
      <!-- CONTAIN_END -->
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<style>
.login-options {
  display: none;
  visibility: hidden;
}
</style>

<script>
import $ from 'jquery';
import Trackeable from '../../Trackeable';
import InputValidated from '../../shared/components/InputValidated';
import { API_URL, PRIZE_URL, STATIC_URL } from '../main';
import { mapFullStoreToParams, isEmptyData, alertAndRedirectToFunnelUrl } from '../utils';
import Globalized from '../../shared/components/Globalized';
import { processError } from '../../shared/utils';
import { getUserTimezoneVar, hideFBButtonByUserAgent, UNINITIALIZED as Status0, COMPLETED as status4 } from '../../shared/constants';

const GENERIC_ERROR_MSG = 'Something went wrong when trying to submit your answers. Please try again or contact support if the problem persists.';

const SIGN_UP_IMAGES = {
  USD: 'prize_banner.png',
  CAD: 'prize_banner_cad.png',
  AUD: 'prize_banner_au.png'
}

const UNINITIALIZED = Status0;
const COMPLETED = status4;

export default {
  name: 'signUp',
  mixins: [Trackeable, InputValidated, Globalized],
  data: function () {
    return {
      email: this.$store.state.initialEmail,
      password: '',
      signUpImg: `${STATIC_URL}img/spa/${SIGN_UP_IMAGES[this.site().currency()]}`,
      lockIcon: `${STATIC_URL}img/payment/lock_icon.svg`,
      accImg: `${STATIC_URL}img/acc-creation-v3-godaddy-warranties.png`,
      step2Img: `${STATIC_URL}img/step_2_img.png`,
      btnClicked: false,
      // eslint-disable-next-line no-undef
      gcaptchaId: gcaptchaId,
      facebookBtnText: 'Continue with Facebook',
      showPassword: false,
      grecaptcha: null,
      showFBButton: true
    }
  },
  created() {
    this.$store.dispatch('getFeatureFlagLoginRequireCaptchaFF');
    this._loadFBSdk();
  },
  computed: {
    shouldRenderRecaptcha: function () {
      if (this.$store.state.loginRequireCaptchaFF) {
        window.onReCaptchaLibraryLoadedCallback = this.onReCaptchaLibraryLoadedCallback
        this._loadCaptcha();
      } else {
        this._unloadCaptcha();
      }
      return (this.$store.state.loginRequireCaptchaFF && this.$store.state.recaptchaLibraryReady)
    }
  },
  mounted: function () {
    // eslint-disable-next-line no-undef
    window.processSignup = this.processSignup;
    this.checkFeaturesAccordingToBrowser();
  },
  methods: {
    getShouldRenderRecaptcha: function () {
      return this.shouldRenderRecaptcha;
    },
    onReCaptchaLibraryLoadedCallback: function () {
      this.$store.dispatch('activateRecaptchaLibraryReady')
    },
    _loadCaptcha: function () { // needed here to run after component loads
      const recaptcha = document.createElement('script');
      recaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onReCaptchaLibraryLoadedCallback');
      recaptcha.className += 'grecaptcha-script';
      document.head.appendChild(recaptcha)
    },
    _unloadCaptcha: function () {
      const gRecaptchaBadge = document.getElementsByClassName('grecaptcha-badge');
      if (gRecaptchaBadge && gRecaptchaBadge.length > 0) {
        gRecaptchaBadge[0].remove();
      }
      const gRecaptchaScript = document.getElementsByClassName('grecaptcha-script');
      if (gRecaptchaScript && gRecaptchaScript.length > 0) {
        gRecaptchaScript[0].remove();
      }
    },
    _loadFBSdk: function () {
      const fbSdk = document.createElement('script');
      fbSdk.setAttribute('src', 'https://connect.facebook.net/en_US/sdk.js');
      fbSdk.onload = this._initializeFB;
      document.head.appendChild(fbSdk)
    },
    _initializeFB: function () {
      window.fbAsyncInit = function () {
        /* eslint-disable */
        FB.init({
          appId: facebookAppId,
          status: false,
          cookie: true,
          xfbml: true,
          oauth: true,
          channelUrl: '//healthywage.com/channel/',
          version: 'v19.0'
        });
        /* eslint-enable */
      };
    },
    processSignup: function (token) {
      document.getElementById('free-password-ok').classList.add('hidden')

      if (this.$store.state.loginRequireCaptchaFF && invalidLoginInput()) { return }
      const self = this;
      self.btnClicked = true;

      const data = mapFullStoreToParams(this.$store.state.nyop);
      Object.assign(data, { email: this.email, password: this.password, timezone: getUserTimezoneVar() });

      this.performSignUp(`${API_URL}/weight-loss-bet/complete_sign_up/`, data, token)
    },
    signUpFacebook: function () {
      const self = this;

      // eslint-disable-next-line no-undef
      FB.login(function (response) {
        // We do nothing if the user cancels
        if (response.status === 'connected') {
          const data = mapFullStoreToParams(self.$store.state.nyop);
          Object.assign(data, { token: response.authResponse.accessToken });
          self.facebookBtnText = 'Loading...';
          self.performSignUp(`${API_URL}/weight-loss-bet/facebook_auth/`, data)
        }
      }, { scope: 'email' });
    },
    performSignUp: function (url, data, token = 'no-captcha') {
      if (this.getShouldRenderRecaptcha()) {
        data.g_recaptcha_response = token || grecaptcha.getResponse()
      } else {
        data.g_recaptcha_response = 'no-captcha'
      }
      if (isEmptyData(data)) {
        alertAndRedirectToFunnelUrl(data);
        return;
      }
      $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        success: this.handleSignUpSuccess,
        error: this.handleSignUpError
      });
    },
    handleSignUpSuccess: function (data, statusText, jqXHR) {
      if (statusText === 'success' && jqXHR.readyState === COMPLETED) {
        let redirectTo = PRIZE_URL
        if (!!data && data.redirect_to) {
          redirectTo = `${API_URL}${data.redirect_to}`;
        }
        window.location.href = redirectTo;
      } else {
        // Just preventive. The server should not respond with code 200 and error.
        processError({ handler: 'Signup Success', statusText, readyState: jqXHR.readyState },
          GENERIC_ERROR_MSG, jqXHR.readyState !== UNINITIALIZED, { status: statusText || 'undefined' },
          jqXHR.readyState === UNINITIALIZED);
      }
    },
    handleSignUpError: function (jqXHR, statusText) {
      if (this.shouldRenderRecaptcha && grecaptcha) {
        grecaptcha.reset()
      }
      if (jqXHR.responseJSON === 'This account already exists.') {
        handleExistingUserError();
      } else if (jqXHR.responseText) {
        appendErrors(jqXHR);
      } else {
        // Unknown. It could be server offline or internal error. Avoid sending cancelled requests.
        processError({ handler: 'Signup Error', statusText, readyState: jqXHR.readyState },
          GENERIC_ERROR_MSG, jqXHR.readyState !== UNINITIALIZED, jqXHR,
          jqXHR.readyState === UNINITIALIZED);
      }
      this.btnClicked = false;
      this.facebookBtnText = 'Continue with Facebook';
    },
    onSignUp: function (event) {
      event.preventDefault(); // to prevent posting form to backend
      this.processSignup()
    },
    togglePassword: function () {
      this.showPassword = !this.showPassword;
    },
    freePasswordLink: function (e) {
      e.preventDefault();
      if (invalidLoginInput()) { return }

      $.ajax({
        type: 'POST',
        url: '/api/v5/auth/login/passwordfree/',
        data: {
          email: this.email,
          next_path: '/healthywager/prize/'
        },
        complete: function (response) {
          document.getElementById('existing-user').classList.add('hidden')

          if (response.responseJSON.email) {
            document.getElementById('free-password-ok').classList.remove('hidden')
          } else {
            renderError(response.responseJSON.detail);
          }
        }
      })
    },
    checkFeaturesAccordingToBrowser: function() {
      if (this.hideFBButton()) {
        this.showFBButton = false;
      }
    },
    hideFBButton: function () {
      const userAgent = navigator.userAgent;
      return hideFBButtonByUserAgent(userAgent);
    }
  }
};

function invalidLoginInput() {
  return !window.$('.step5').valid()
}

function handleExistingUserError() {
  document.getElementById('existing-user').classList.remove('hidden');
  $('#existing-user label').show();
}

// handle errors from:
// responseJSON.non_field_errors => list with one error as string
// responseJSON.responseJSON => string of the unique error
// responseJSON.responseJSON => object with multiple errors
function appendErrors(errorObj) {
  if (!errorObj.responseJSON) {
    alert(GENERIC_ERROR_MSG);
    return;
  }

  if (errorObj.responseJSON.non_field_errors) {
    renderError(errorObj.responseJSON.non_field_errors[0])
  } else if (typeof errorObj.responseJSON === 'string') {
    renderError(errorObj.responseJSON)
  } else {
    Object.keys(errorObj.responseJSON).forEach((key) => errorObj.responseJSON[key].forEach((errorValue) => {
      renderError(`${key}: ${errorValue}`)
    }));
  }
}

function renderError(errorMsg) {
  $('.step5 .main-form').append(`<div id="status" class="validation-errors"><label class="error">${errorMsg}</label></div>`)
}

</script>
